import { render, staticRenderFns } from "./IndexAD.vue?vue&type=template&id=15a76d3f&scoped=true&"
import script from "./IndexAD.vue?vue&type=script&lang=js&"
export * from "./IndexAD.vue?vue&type=script&lang=js&"
import style0 from "./IndexAD.vue?vue&type=style&index=0&id=15a76d3f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a76d3f",
  null
  
)

export default component.exports